import { render, staticRenderFns } from "./StafferTable.vue?vue&type=template&id=d561e5d2&scoped=true"
import script from "./StafferTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./StafferTable.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d561e5d2",
  null
  
)

export default component.exports